import { render, staticRenderFns } from "./singapore10YearsTC.vue?vue&type=template&id=1b6fab38&scoped=true&"
import script from "./singapore10YearsTC.vue?vue&type=script&lang=js&"
export * from "./singapore10YearsTC.vue?vue&type=script&lang=js&"
import style0 from "./singapore10YearsTC.vue?vue&type=style&index=0&id=1b6fab38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6fab38",
  null
  
)

export default component.exports